export type IndicatorPosition = "top" | "bottom";

/** The virtualiser's currently visible index range, before overscan is applied. */
export type VisibleRange = { startIndex: number; endIndex: number } | null;

/**
 * Which edge indicator should flash for a row that has just re-appeared in the list — or none, if
 * the row is already on screen and needs no pointing at.
 *
 * The range must be the pre-overscan one: `getVirtualIndexes()` includes rows rendered just outside
 * the viewport, which would count an off-screen row as visible and suppress the indicator entirely.
 */
export const pickIndicator = (index: number, range: VisibleRange): IndicatorPosition | null => {
    if (index === -1 || !range) {
        return null;
    }

    if (index < range.startIndex) {
        return "top";
    }

    return index > range.endIndex ? "bottom" : null;
};
